export default __webpack_public_path__ + "static/media/oluseun.79b78362.jpg";